export default ".revertCnt h4 {\n  font-weight: 500;\n  color: #18406e;\n}";